"use strict";

exports.__esModule = true;
var _CreateReportScreen = require("./CreateReportScreen");
Object.keys(_CreateReportScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateReportScreen[key]) return;
  exports[key] = _CreateReportScreen[key];
});